module.exports = postalRates;